import { render, staticRenderFns } from "./DashboardCalendar.vue?vue&type=template&id=4a13f08f&"
import script from "./DashboardCalendar.vue?vue&type=script&lang=js&"
export * from "./DashboardCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports